import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopBar from './components/TopBar';
import Header from './components/Header';
import HomeSlider from './components/HomeSlider';
import EmpresaSlider from './components/EmpresaSlider';
import Services from './components/Services';
import Productos from './components/Productos';
import Procesos from './components/Procesos';
import Clientes from './components/Portfolio';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <TopBar />
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <HomeSlider />
              <EmpresaSlider />
              <Services />
              <Productos />
              <Procesos />
              <Clientes />
              <Contact />
            </>
          } />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
